import React from 'react';
import PageHeaderNavigation, { type PageHeaderNavigationProps } from './common/PageHeaderNavigation';

type PageHeaderProps = PageHeaderNavigationProps;

const PageHeader: React.FC<PageHeaderProps> = (props) => <PageHeaderNavigation {...props} />;

export default PageHeader;
